// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"19bd419b","723":"939a57c7","771":"19bd419b","773":"428027cc"}[chunkId] + ".chunk.css";
};